// assets
import { BarChart, Payment, PeopleAlt } from "@mui/icons-material";
import DomainIcon from "@mui/icons-material/Domain";
import SettingsIcon from "@mui/icons-material/Settings";
import { RoleLevel } from "../../../../../../../domain/entities/Role";

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const administrator = {
  id: "administrator",
  title: "Administration",
  caption: "Users & Permissions",
  type: "group",
  level: RoleLevel.Administrator,
  // Closed when the app loads; the other groups start open. Any group opens itself when
  // it contains the current page.
  defaultOpen: false,
  children: [
    {
      id: "metrics",
      title: "Metrics",
      type: "item",
      icon: BarChart,
      color: "#5E35B1",
      url: "/metrics",
      breadcrumbs: false,
    },
    {
      id: "users",
      title: "Users",
      type: "item",
      icon: PeopleAlt,
      color: "#1976D2",
      url: "/users",
      breadcrumbs: false,
    },
    {
      id: "organizations",
      title: "District & School",
      type: "item",
      icon: DomainIcon,
      color: "#00ACC1",
      url: "/organizations",
      breadcrumbs: false,
    },
    {
      id: "configurations",
      title: "Configurations",
      type: "item",
      icon: SettingsIcon,
      color: "#607D8B",
      url: "/configurations",
      breadcrumbs: false,
    },
    {
      id: "payments",
      title: "Payments",
      type: "item",
      icon: Payment,
      color: "#A2981C",
      url: "/payments",
      breadcrumbs: false,
    },
  ],
};

export default administrator;
